import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';

import './VeFormularPrint.css';

type printFieldsType = {
  key: string;
  label: string;
  content: string;
}

function VeFormularPrint() {
  const [urlPrintParams] = useSearchParams();
  const veId = urlPrintParams.get('veId');
  const beAbk = urlPrintParams.get('abk');
  const beName = urlPrintParams.get('name');
  const fId = urlPrintParams.get('fId');
  const [headerFields, setHeaderFields] = useState<Array<printFieldsType>>([]);
  const [bodyFields, setBodyFields] = useState<Array<printFieldsType>>([]);

  useEffect(() => {
    const url = '/webclient/php/print_ve.php?&ob_id=' + veId + '&f_id=' + fId;

    fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error('Anfrage fehlgeschlagen');
        }
        return res.json();
      })
      .then((data) => {
        console.log(data);
        setHeaderFields(data.filter((f: { type: string; }) => f.type === 'header'));
        setBodyFields(data.filter((f: { type: string; }) => f.type === 'body'));
      })
      .catch((err) => {
        console.log(err.message);
      });
  }, []);

  console.log(bodyFields);

  return (
    <div className="print-container">
      <h1>Details der Verzeichnungseinheit</h1>
      <dl className="header-fields-list">
        <div>
          <dt>Bestand:</dt>
          <dd>{`${beAbk} - ${beName}`}</dd>
        </div>
        {headerFields.map((field) => (
          <div>
            <dt>{field.label}:</dt>
            <dd>{field.content}</dd>
          </div>
        ))}
      </dl>
      <hr />
      <dl className="body-fields-list">
        {bodyFields.map((field) => (
          <div>
            <dt>{field.label}:</dt>
            <dd>{field.content}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}

export default VeFormularPrint;
